import { Chart, tokens } from "@sunrun/experience-ui-components";
import { ChartProps } from "@sunrun/experience-ui-components/lib/components/Chart/Chart";

const TargetZoneGraph = ({ data }: { data: Partial<ChartProps> }) => {
  return (
    <Chart
      xLabel="month"
      xLabelFormat={(label) => label?.toString().charAt(0)}
      showXGrid
      howManyXAxis={4}
      legendData={[
        {
          name: "Target Zone",
          symbol: {
            type: "minus",
            stroke: tokens.TINTS_SUCCESS_70,
            strokeWidth: 1,
            fillOpacity: 0.5,
            fill: tokens.TINTS_SUCCESS_70,
          },
        },
        {
          name: "Est. Energy Usage",
          symbol: { fill: tokens.BRAND_CHARGEBLUE },
        },
      ]}
      domainPadding={30}
      barRatio={0.5}
      toolTipAlignment={-125}
      toolTipFontSize={18}
      useToolTip={true}
      legendOffsetY={-20}
      legendOffsetX={10}
      addedBottomPadding={20}
      mobileLegend={{
        itemsPerRow: 1,
        padding: 40,
        offsetY: -40,
      }}
      toolTipLabelProps={{
        dx: -125,
        style: [
          {
            fontWeight: "500",
            fontFamily: "Roobert, sans-serif",
            fill: tokens.HEROBLUE_20,
            fontSize: "20px",
          },
          ...new Array(4).fill({
            fontWeight: "300",
            fontFamily: "Roobert, sans-serif",
            fill: tokens.HEROBLUE_20,
            fontSize: "16px",
          }),
        ],
      }}
      toolTipPointerLength={20}
      toolTipPointerWidth={40}
      toolTipProps={{
        constrainToVisibleArea: false,
        flyoutStyle: {
          strokeWidth: 30,
          stroke: tokens.TINTS_INFO_80,
          fill: tokens.TINTS_INFO_80,
          minWidth: 300,
        },
      }}
      styles={{
        area: {
          data: {
            stroke: tokens.TINTS_SUCCESS_70,
            strokeWidth: 1,
            fillOpacity: 0.5,
            fill: tokens.TINTS_SUCCESS_70,
          },
        },
        primaryLine: {
          data: {
            stroke: tokens.TINTS_SUCCESS_70,
            strokeWidth: 1,
          },
        },
      }}
      primaryLineLabels={[""]}
      {...data}
    />
  );
};

export { TargetZoneGraph };
